import { JWT_KEY } from "@/constants";
import { IUser } from "@/types";
import { create } from "zustand";

type IUserTask = {
  updateUser: (user: IUser) => void;
};

interface IUserTaskState {
  user: IUser;
}

export const useUserStore = create<IUserTaskState & IUserTask>((set) => ({
  user: { isLogin: Boolean(localStorage.getItem(JWT_KEY)) },
  updateUser: (state) => set(() => ({ user: { ...state } })),
}));

export const updateUser = (userData: IUser) =>
  useUserStore.getState().updateUser(userData);
